import { createContext, useContext, useEffect } from 'react';

export const CalculatorStatusContext = createContext(null);
export const calculatorStatuses = {
  'not-started': { label: 'Not started', color: 'grey' },
  'in-progress': { label: 'In progress', color: 'blue' },
  calculating: { label: 'Calculating', color: 'blue' },
  calculated: { label: 'Calculated', color: 'green' },
  'review-required': { label: 'Review required', color: 'yellow' },
  'action-required': { label: 'Action required', color: 'red' },
};

export function getCalculatorStatus({ busy, result, errors = {}, status, initialMessage }) {
  if (busy) return 'calculating';
  if (Object.keys(errors).length || status?.startsWith('Unable')) return 'action-required';
  if (result) {
    return Object.keys(result.calculationErrors || {}).length || result.comparison?.comparable === false
      ? 'review-required' : 'calculated';
  }
  if (status === initialMessage) return 'not-started';
  return 'in-progress';
}

export function useCalculatorStatus(state) {
  const updateStatus = useContext(CalculatorStatusContext);
  const status = getCalculatorStatus(state);
  useEffect(() => { updateStatus?.(status); }, [updateStatus, status]);
}
